/* Collection filtering.

   Four jobs:
   1. Keep sort and filters in one submission. They used to be separate forms,
      so applying a filter dropped the sort and changing the sort cleared the
      filters. The select mirrors into a hidden input inside the filter form.
   2. Drive the mobile drawer — below lg the sidebar is off-canvas, its groups
      collapse, and selections are batched behind a Show results button so a
      phone shopper does not pay a page load per filter.
   3. Load more, appending the next page in place instead of paging through
      185 pages of numbered links.
   4. Search within a facet, for the brand lists that run to Shopify's
      100-value cap.

   Empty inputs are stripped before submit so blank price fields stop
   polluting the URL with `filter.v.price.gte=&filter.v.price.lte=`. */
(function () {
  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var form = root.querySelector('[data-filter-form]');
  var sortSelect = root.querySelector('[data-sort-select]');
  var sortMirror = root.querySelector('[data-sort-mirror]');
  var facets = root.querySelector('[data-facets]');

  /* ---- one form: never submit empty params ---- */
  function submitFilters() {
    if (!form) return;
    if (sortMirror && sortSelect) sortMirror.value = sortSelect.value;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && el.type !== 'checkbox' && el.type !== 'submit' && el.value === '') {
        el.disabled = true; // disabled fields are omitted from the query string
      }
    });
    form.submit();
  }

  /* While the drawer is open — i.e. on a phone — selections are batched behind
     the Show results button. Submitting on every tick would cost a page load
     per filter and close the drawer each time. The sidebar on desktop, where
     the drawer is never open, still submits on change. */
  function drawerOpen() {
    return !!(facets && facets.classList.contains('is-open'));
  }

  var applyBtn = root.querySelector('[data-facets-apply]');
  function refreshApply() {
    if (!applyBtn || !form) return;
    var n = form.querySelectorAll('input[type="checkbox"]:checked').length;
    applyBtn.textContent = n ? 'Show results (' + n + ')' : 'Show results';
  }

  if (form) {
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="checkbox"]')) return;
      if (drawerOpen()) { refreshApply(); return; }
      submitFilters();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFilters();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      // carry the current filters along rather than starting a fresh query
      if (form) { submitFilters(); return; }
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSelect.value);
      window.location.href = u.toString();
    });
  }

  /* ---- collapsible groups (phone only) ----
     Household shows 61 options across 3 groups. Expanded, that is 2,700px of
     drawer to scroll past; collapsed, every group is one tap away. Groups the
     shopper has already filtered on start open. Desktop leaves them all open. */
  var groups = root.querySelectorAll('[data-facet]');
  function collapsible() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
  function setGroup(group, open) {
    var toggle = group.querySelector('[data-facet-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  /* On desktop nothing collapses, so the header should not announce itself as
     an expandable control or take a tab stop. */
  function setToggleActive(group, active) {
    var toggle = group.querySelector('[data-facet-toggle]');
    if (!toggle) return;
    if (active) {
      toggle.removeAttribute('tabindex');
    } else {
      toggle.setAttribute('tabindex', '-1');
      toggle.removeAttribute('aria-expanded');
    }
  }
  function syncGroups() {
    var collapse = collapsible();
    groups.forEach(function (group) {
      setToggleActive(group, collapse);
      if (!collapse) return;
      /* All collapsed unless already in use, so the four group headers are
         scannable in one screen instead of one long list pushing the rest down. */
      setGroup(group, group.hasAttribute('data-facet-active'));
    });
  }
  syncGroups();
  window.addEventListener('resize', syncGroups);
  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-facet-toggle]');
    if (!toggle || !collapsible()) return;
    e.preventDefault();
    toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });

  /* ---- mobile drawer ---- */
  function openFacets() {
    facets.classList.add('is-open');
    document.body.classList.add('lum-drawer-open');
    document.body.style.overflow = 'hidden';
    refreshApply();
    var close = facets.querySelector('[data-facets-close]');
    if (close && close.focus) close.focus();
  }
  function closeFacets() {
    facets.classList.remove('is-open');
    document.body.classList.remove('lum-drawer-open');
    document.body.style.overflow = '';
    /* Dismissing the drawer discards the batch. Otherwise ticks that were never
       applied stay ticked, disagreeing with the chips and the URL. */
    if (form) { form.reset(); refreshApply(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-facets-open]')) { e.preventDefault(); openFacets(); return; }
    if (e.target.closest('[data-facets-close]')) { e.preventDefault(); closeFacets(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && facets && facets.classList.contains('is-open')) closeFacets();
  });

  /* ---- facet search: a 100-item brand list needs a way in ---- */
  root.querySelectorAll('[data-facet-search]').forEach(function (input) {
    var group = input.closest('[data-facet]');
    var options = group.querySelectorAll('[data-facet-option]');
    var none = group.querySelector('[data-facet-none]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      options.forEach(function (li) {
        var match = !q || li.getAttribute('data-facet-option').indexOf(q) !== -1;
        li.hidden = !match;
        if (match) shown++;
      });
      if (none) none.hidden = shown !== 0;
    });
  });

  /* ---- load more ---- */
  var btn = root.querySelector('[data-load-more]');
  if (btn) {
    var grid = root.querySelector('[data-product-grid]');
    var status = root.querySelector('[data-load-status]');
    var loading = false;

    btn.addEventListener('click', function () {
      var next = btn.getAttribute('data-next');
      if (!next || loading) return;
      loading = true;
      var original = btn.textContent;
      btn.textContent = 'Loading…';
      btn.disabled = true;

      fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-product-grid]');
          if (!incoming) throw new Error('no grid in response');
          // move the cards over rather than replacing the grid, so the ones
          // already on screen keep their state
          while (incoming.firstElementChild) grid.appendChild(incoming.firstElementChild);

          var nextBtn = doc.querySelector('[data-load-more]');
          if (nextBtn && nextBtn.getAttribute('data-next')) {
            btn.setAttribute('data-next', nextBtn.getAttribute('data-next'));
            btn.textContent = original;
            btn.disabled = false;
          } else {
            btn.remove();
          }
          var nextStatus = doc.querySelector('[data-load-status]');
          if (status && nextStatus) status.textContent = nextStatus.textContent;
          // keep the URL shareable at the depth the shopper has reached
          try { history.replaceState({}, '', next); } catch (e) { /* no-op */ }
        })
        .catch(function () {
          // fall back to a normal page load rather than stranding the shopper
          window.location.href = next;
        })
        .finally(function () { loading = false; });
    });
  }
})();
